
class MultiBundle extends HTMLElement {
  constructor() {
    if (!window.theme.enable_start) document.querySelector('.loader').classList.add('show');

    super();
    if (window.location.href.includes('multibundle-mens-fit13') || window.location.href.includes('multibundle-mens-fit8')) {
      this.changeVisualPrices('', '');
    }

    this.translateInfo();
    this.setDomSelectors();
    this.setGlobalStates();
    this.init();

    /* click listeners */
    this.styleSelectionListener();
    this.nextButtonListener();
    this.backButtonListener();

    this.setGlobalStatesClasses();

    /* ab test #59ab2e4d-6a20-4319-8725-d2eecd799518 */
    this.abTestV1 = false;
    window.addEventListener("message", (event) => {
      /*
      if Intelligems is uninstalled this will not be triggered
      */
      if (event.data === "ig-ready") {
        return;
      }
    });
   
    this.setupSliderMover();
  }
  /**
   * Initial Method
   */
  init() {

    this.loadCollectionHandles().then(() => {
      this.fetchProductsFromCollections().then(() => {
        this.startBuildingEvent();
        if (!this.enable_start) {
          setTimeout( this.startBuildingWithoutButton(), 300);
        }
        this.productSelectionListener();
        this.addToCartEvent();
        this.hoverProductEvent();

        this.startBuildingBtn.disabled = false;
        this.startBuildingBtn.classList.remove("loading");
        this.freeShippingAmount();

      });
    });
  }
  intelligemsChanges() {
    const testObject = window.igData.user.getTestGroup('3a8f0d7a-6644-43de-a34d-7e0d637d722d');
    
    if (testObject) {
      //const { name, isControl } = testObject;
      if (testObject.name.includes('V1')) {
        this.overWriteDiscountFTC();
      } else if (testObject.isControl) {
        
      }
    } else {
      
    }
  }
  intelligemsVariant1() {
    this.abTestV1 = true;
    this.priceFromTo.classList.remove('hidden');
    this.priceFromTo.classList.add('v1-ab-test');
    this.discountRef = "000000";
    this.discountPercentage = 0;
    this.querySelector('#mb__preview-prices').classList.add('v1-ab-test');
    this.querySelector('.mb__preview-footer .multibundle-badge').innerHTML = window.theme.free_shipping_text;
    this.querySelector('#cards-top .multibundle-badge').innerHTML = window.theme.free_shipping_text;
    this.querySelector('#cards-top .multibundle-badge').classList.remove('hidden');
  }
 
  changeVisualPrices(total, discounted) {
    if (total != '' && discounted != '') {
      this.querySelector('.mb__preview-prices-total').innerHTML = ` ${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(total)} ${window.theme.shop_currency}`;
      this.querySelector('.mb__preview-prices-discounted').innerHTML = `${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(discounted)} ${window.theme.shop_currency}`;
    }
  }
  chinosAbTest() {
    const testObject = window.igData.user.getTestGroup('9a41cffd-832a-4344-8556-59dec3e4c247');
    if (testObject) {
      const { name, isControl } = testObject;
      // if url includes multibundle-mens-fit13 or multibundle-mens-fit8
      if (window.location.href.includes('multibundle-mens-fit13')) {
        if (testObject) {
          if (testObject && name.includes('V1')) {
            this.changeVisualPrices(290, 261);
          } else if (testObject && name.includes('V2')) {
            this.changeVisualPrices(300, 270);
          } else if (isControl) {
            this.changeVisualPrices(280, 252);
          }
        }

      } else if (window.location.href.includes('multibundle-mens-fit8')) {
        if (testObject) {
          if (testObject && name.includes('V1')) {
            this.changeVisualPrices(203, 183);
          } else if (testObject && name.includes('V2')) {
            this.changeVisualPrices(213, 192);
          } else if (isControl) {
            this.changeVisualPrices(193, 173);
          }
        }
      }
    }
  }
  setupSliderMover() {
    this.slider = document.querySelector(".product__media-wrapper");
    this.targetDiv = document.querySelector(".mobile-product-images");
    this.originalParent = this.slider?.parentElement;

    if (this.slider && this.targetDiv) {
      this.moveSlider();
      window.addEventListener("resize", this.moveSlider.bind(this));
    }
  }

  moveSlider() {
    if (!this.slider || !this.targetDiv || !this.originalParent) return;

    if (window.innerWidth <= 768) {
      this.targetDiv.appendChild(this.slider);
    } else {
      this.originalParent.appendChild(this.slider);
    }
  }
  freeShippingAmount() {
    if (Shopify.country != "US") {
      let freeShippingContainer = document.getElementById('mb-free-shipping-container');
      if (freeShippingContainer) freeShippingContainer.innerHTML = `50`;
    }
  }

  translateInfo() {
    this.domain = `${Shopify.routes.root}`;
    this.waist_text = window.theme.waist_text ? window.theme.waist_text : 'Waist';
    this.size_text = window.theme.size_text ? window.theme.size_text : 'Size';
    this.inseam_text = window.theme.inseam_text ? window.theme.inseam_text : 'Insem';
    this.color_text = window.theme.color_text ? window.theme.color_text : 'Color';
    this.style_text = window.theme.style_text ? window.theme.style_text : 'Inseam';
    this.edit_text = window.theme.edit_text ? window.theme.edit_text : 'Edit';
  }
  /**
   * Global Dom Selectors
   */
  setDomSelectors() {
    this.productSelectors = this.querySelectorAll(".mb__product-selector");
    this.itemSelectors = this.querySelectorAll(".mb__interface-item");
    this.styleListSelectors = this.querySelectorAll(
      ".mb__interface-style-list"
    );
    this.priceFromTo = this.querySelector(".mb-price-fromto");
    this.styleSelectors = this.querySelectorAll(".mb__interface-style-btn");
    this.nextButtonsSelectors = this.querySelectorAll(
      ".mb__interface-next-button"
    );
    this.backButtonsSelectors = this.querySelectorAll(
      ".mb__interface-back-button"
    );

    this.startBuildingBtn = this.querySelector("#start-building");
    this.bundleInterface = this.querySelector("#mb-interface");
    this.titleProduct = this.querySelector("#multi-product-title");
    this.startBuilding = this.querySelector("#start-building-container");
    this.previewInterface = this.querySelector("#mb__preview");
    this.addtoCartBtn = this.querySelector("#mb__atc-btn");
    this.mainProductJSONSelector = this.querySelector("#main-product");
    this.customSizeGuide = this.querySelector("#custom-size-guide");
    this.preorderNote = this.querySelector(".pre-order-note");
  }
  /**
   * Global variables that uses another custom HTML javascript class
   */
  setGlobalStatesClasses() {
    this.variantRadio = this.querySelector("variant-radios");
    this.sidecart = document.querySelector("side-cart");
    this.prodImagesSlider = this.querySelector("product-images-slider");
    this.descriptionTab = this.querySelector("description-tab");
    this.descriptionTabRet = this.querySelector("#returns-tab");
    //console.log(this.descriptionTab);
  }
  setGlobalStates() {
    this.collectionHandles = [];
    this.selectedItem = 0;
    this.selectedStyle = 0;
    this.selectedProduct = {};
    this.availableProducts = [];
    this.selectedCombinations = [];
    this.discountRef = '';
    this.mbStep = 1;
    this.ftcEnabled = true;

    this.commonSelections = [
      {
        type: "jean",
        combination: { waist: 30, inseam: 32 },
      },
      {
        type: "tee",
        combination: { size: "M" },
      },
    ];

    if (this.mainProductJSONSelector) {
      const jsonString = this.mainProductJSONSelector.innerHTML;
      const productObject = JSON.parse(jsonString);
      this.ftcDiscountPercentage = productObject.bundle_info.ftc_discount_percentage || null;
      this.discountPercentage = productObject.bundle_info.discount_percentage;

      this.discountFtcRef = productObject.bundle_info.discount_ftc_ref;
      this.discountRef = productObject.bundle_info.discount_ref;
      this.checkoutThumbnail = productObject.checkout_thumbnail;
    }

    this.totalPrice = '';

    this.enable_start = window.theme.enable_start;
    this.enable_review = window.theme.enable_review;
    this.pre_order_date = window.theme.pre_order_date;
  }
  /**
   * Get the collection Handles from the section .liquid script
   */
  async loadCollectionHandles() {
    const scriptElement = document.querySelector("#collection-list");
    if (scriptElement) {
      const jsonString = scriptElement.innerHTML;
      this.collectionHandles = JSON.parse(jsonString).map((e) => e.handle);
    }
  }
  /**
   * Get products info from a request based on the collection handles
   */
  async fetchProductsFromCollections() {
    const uniqueHandles = [...new Set(this.collectionHandles)];
    const fetchPromises = uniqueHandles.map((handle, index) => {
      console.time(`Request ${index + 1}`);
      return fetch(
        `${this.domain}collections/${handle}?view=bundledata`
      )
        .then((res) => res.text())
        .then((json) => {
          const products = JSON.parse(json);
          this.availableProducts.push(...products);
          this.evaluateIfExists(products);
        });
    });

    await Promise.all(fetchPromises);
    console.log("All requests completed.");
  }

  async addtoCartFetch(body) {
    return fetch(`/cart/add`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        console.log(response);
        return response;
      })
      .catch((error) => {
        console.error("Error:", error);
        throw error; // Optional: Rethrow the error to handle it further up the call stack
      });
  }

  async addToCartEvent() {
    // add to cart logic here...
    this.addtoCartBtn.addEventListener("click", async (btn) => {
      await this.addToCartAction();
    });
  }

  async addToCartAction() {
    this.addtoCartBtn.disabled = true;
    this.addtoCartBtn.classList.add("loading");
    //console.log(this.selectedCombinations);
    let productObject = {};
    if (this.mainProductJSONSelector) {
      const jsonString = this.mainProductJSONSelector.innerHTML;
      productObject = JSON.parse(jsonString);
      //console.log(productObject);
    }

    let actBody = [];

    let price_mb = 0;
    let multibundle_id = String(Date.now());
    let images = [];
    let itemsForMinicart = [];

    price_mb = this.selectedCombinations.map((item) => {
      const variant = JSON.parse(item.variant);
      return variant.price;
    }).reduce((a, b) => a + b, 0) / 100;

    const discountedTotalPrice = this.selectedCombinations.map((item) => {
     
      const variant = JSON.parse(item.variant);
      const price =((variant.price / 100) - ((variant.price / 100) * (this.discountPercentage / 100)));
      return price;
    }).reduce((a, b) => a + b, 0);
    

    this.selectedCombinations.forEach((item, index) => {
      const variant = JSON.parse(item.variant);
      //price += variant.price;
      images.push(item.product.featured_image);
      itemsForMinicart.push({
        product: {
          title: item.product.title,
        },
        variant: {
          title: variant.title,
        },
      });
      //console.log("productObject",productObject);
      //
      
      const price =((variant.price / 100) - ((variant.price / 100) * (this.discountPercentage / 100)));
      const discountedPrice = (price % 1 !== 0) ? price.toFixed(2) : price.toFixed(0);
      actBody.push({
        id: variant.id,
        quantity: 1,
        properties: {
          _multibundle_id: multibundle_id,
          _multibundleItem: true,
          _item_pack: true,
          _parent_id: String(productObject.main_product.variants[0].id),
          _multibundle_discount_ref: this.discountRef,
          _grandparent_id: productObject.main_product.id,
          _bundle_image: this.checkoutThumbnail,
          _original_price: price_mb, 
          _total_price: discountedTotalPrice,
          _parent_name : productObject.main_product.title,
          'Original price' : `${window.theme.cart_currency_symbol} ${variant.price / 100}`,
          'Discounted price': `${window.theme.cart_currency_symbol} ${discountedPrice}`,
          ...(this.pre_order_date ? { 'Pre-Order': this.pre_order_date } : {})
        },
      });
    });

    
    //alert(priceFull);
    //return;
    let has_no_discount = this.abTestV1 ? true : false;
    console.log('actBody', actBody);
    /*actBody.push({
      id: productObject.first_available_variant.id,
      quantity: 1,
      properties: {
        total_price: priceFull,
        discount_price: discountedPrice,
        originalprice: priceFull,
        packPrice: discountedPrice,
        dummyPack: true,
        'ig-v2-mb': this.abTestV1 ? '58cs3r32fusa' : '',
        bundle_without_discount: has_no_discount,
        multibundle_discount_ref: this.discountRef,
        multibundle_main: true,
        multibundle_id: multibundle_id,
        bundle_index: multibundle_id,
        bundle_images: images,
        items_info: itemsForMinicart,
        checkout_thumbnail: this.checkoutThumbnail,
        message: `MULTIBUNDLES_MAIN || ${priceFull},${discountedPrice} || ${JSON.stringify(
          itemsForMinicart
        )}`
      },
    });*/



    await this.addtoCartFetch(JSON.stringify({ items: actBody }));
    this.sidecart.getCart();
    this.sidecart.openCart();
    this.resetBundle();
    return;
    let attributes = {
      attributes: {
        _selected_chart: JSON.parse(selectedCharts),
      },
    };

    let body = JSON.stringify(chart_obj);
    await this.addtoCartFetch();

  }

  hoverProductEvent() {
    if (window.innerWidth > 900) {
      this.productSelectors.forEach((item) => {
        item.addEventListener("mouseenter", () => {
          const hoveredProduct = this.availableProducts.find(
            (x) => x.id == item.dataset.productId
          );

          if (item.dataset.productId != this.selectedProduct.id)
            this.prodImagesSlider.reInitSlider(hoveredProduct);
        });

        item.addEventListener("mouseleave", () => {
          if (item.dataset.productId != this.selectedProduct.id)
            this.prodImagesSlider.reInitSlider(this.selectedProduct);
        });
      });
    }
  }

  startBuildingEvent() {
    this.startBuildingBtn.addEventListener("click", (_) => {
      //alert('clicked');
      this.startBuilding.classList.add("hidden");
      this.priceFromTo.classList.add("hidden");
      this.bundleInterface.classList.remove("hidden");
      this.bundleInterface.classList.add("active");
      this.descriptionTab.classList.remove("hidden");
      this.descriptionTabRet.classList.remove("hidden");

      this.setSetectedItem(0);

      if (this.addtoCartBtn.disabled) this.addtoCartBtn.disabled = false;
      if (this.addtoCartBtn.classList.contains("loading")) this.addtoCartBtn.classList.remove("loading");
    });
  }

  startBuildingWithoutButton() {
    //alert('clicked');
    this.startBuilding.classList.add("hidden");
    //this.priceFromTo.classList.add("hidden");
    this.bundleInterface.classList.remove("hidden");
    this.bundleInterface.classList.add("active");
    this.descriptionTab.classList.remove("hidden");
    this.descriptionTabRet.classList.remove("hidden");

    this.setSetectedItem(0);

    if (this.addtoCartBtn.disabled) this.addtoCartBtn.disabled = false;
    if (this.addtoCartBtn.classList.contains("loading")) this.addtoCartBtn.classList.remove("loading");

    this.classList.remove('visibility-hidden');
    document.querySelector('.loader').classList.remove('show');
  }
  overWriteDiscountFTC() {
    
    if (this.ftcDiscountPercentage && this.ftcEnabled && localStorage.getItem('ismbc') == 0) {
      this.discountPercentage = this.ftcDiscountPercentage;
      this.discountRef = this.discountFtcRef;
      const discountText = this.querySelectorAll('.multibundle-badge');
      // the new discount text is been set this way to prevent if the badge has a text after the discount percentage
      discountText.forEach((item) => {
        const textSplit = item.textContent.split('%');
        const newText = `${this.ftcDiscountPercentage}% ${textSplit[1]}`;
        item.textContent = newText;

      });
    }
  }
  setSetectedItem(index) {
    this.itemSelectors.forEach((item) => {
      item.classList.remove("active");
    });
    this.itemSelectors[index].classList.add("active");

    this.styleListSelectors.forEach((item) => {
      item.classList.remove("active");
      item.classList.add("hidden");
    });

    this.styleListSelectors[index].classList.remove("hidden");
    this.styleListSelectors[index].classList.add("active");

    this.setSetectedStyle(`product-list-item-${index}-style-0`);

    const type = this.itemSelectors[index].dataset.itemType;
    if (type == 'jean') {
      this.querySelector("#mb-coolor-label").innerHTML = `${this.style_text}`;
    } else {
      this.querySelector("#mb-coolor-label").innerHTML = `${this.color_text}`;
    }

    if (index != 0) {
      this.itemSelectors[index - 1].classList.add("checked");
    }
    this.dataset.itemType = this.itemSelectors[index].dataset.itemType;
  }
  evaluateIfExists(products) {
    products.forEach((product) => {
      const productSelectors = this.querySelectorAll(
        `.mb__product-selector[data-product-id="${product.id}"]`
      );
      if (productSelectors && productSelectors.length > 0) {
        productSelectors.forEach((selector) => {
          if (selector) {
            selector.classList.remove("hidden");
          }  
        });
      }
    });
  }
  productSelectionListener() {
    this.productSelectors.forEach((btn) => {
      btn.addEventListener("click", () => {
        const productId = btn.dataset.productId;
        const productType = btn.dataset.productType;

        this.setSelectedProduct(productId, btn.dataset.styleId);
      });
    });
  }
  styleSelectionListener() {
    this.styleSelectors.forEach((_) => {
      _.addEventListener("click", (btn) => {
        let styleId = _.dataset.styleId;

        this.setSetectedStyle(styleId);
      });
    });
  }
  setSetectedStyle(style) {
    // remove the active class of else buttons
    this.styleSelectors.forEach((button) => {
      button.classList.remove("active");
    });

 

    // recognize the selected style btn
    const btn = this.querySelector(`button[data-style-id="${style}"]`);
    
    if (btn.textContent.includes('Slim Straight')) {
      this.querySelector('.slim-straight').classList.remove('hidden');
    } else {
      this.querySelector('.slim-straight').classList.add('hidden');
    }

    this.selectedStyle = style;
    // add the active class to the btn
    //alert('ll')
    console.log(style);
    console.log(btn);
    btn.classList.add("active");
    const targetId = btn.dataset.togglerId;
    const targetElement = document.getElementById(targetId);
    const targetClass = btn.dataset.togglerClass;

    if (targetElement && targetClass) {
      const elementsToToggle = document.querySelectorAll(`.${targetClass}`);
      elementsToToggle.forEach((element) => {
        element.classList.remove("active");
        element.classList.add("hidden");
      });

      targetElement.classList.remove("hidden");
      targetElement.classList.add("active");
    } else {
      //alert('00')
    }

    this.selectedStyle = style;

    this.setSelectedProduct(btn.dataset.firstProductId, style);
    sortColors();
  }
  wairSizeGuideAttribute(product) {
    const wairDiv = this.querySelector(".predict-placement");
    if (wairDiv) {
      wairDiv.dataset.predictProductKey = product.handle;
      wairDiv.dataset.predictProductName = product.title;
      wairDiv.dataset.predictProductImg = product.featured_image;
    }
  }

  setSelectedProduct(productId, style) {

    const product = this.availableProducts.find((x) => x.id == productId);
    if (!product) {
      //alert(
      //  `METAFIELD ERROR ! :  Please make sure this product ${productId} is on some of the collections handle metafield list`
      //);

      const firstAvailableProduct = Array.from(this.productSelectors).find((item) => {
        return item.classList.contains('hidden') == false && item.dataset.styleId == style;
      });
      
      this.setSelectedProduct(firstAvailableProduct.dataset.productId, style);
      
      return;
    } else {
      this.variantRadio.dataset.tags = product.tags;
    }

    const btn = this.querySelector(
      `.mb__interface-product-list[data-style-id="${style}"] .mb__product-selector[data-product-id="${product.id}"]`
    );

    this.selectedProduct = product;
    this.productSelectors.forEach((element) => {
      element.classList.remove("active");
    });
    btn.classList.add("active");

    if (this.descriptionTab)
      this.descriptionTab.reInitTabs(product.description);

    if (this.prodImagesSlider) this.prodImagesSlider.reInitSlider(product);
    const firstColor = product.options_with_values.find(
      (option) => option.name === "Color" || option.name === "Couleur"
    ).values[0];

    if (this.titleProduct && firstColor)
      this.titleProduct.innerHTML =
        `<svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
      <path d="M9 6L-4.89399e-07 11.1962L-3.51373e-08 0.803847L9 6Z" fill="#292E30"/>
    </svg>  <p> <b>${product.title}</b> ${firstColor}</p>`;
    if (product.handle.includes('bcst-')) {
      this.querySelector('.boxy-crop').classList.remove('hidden');
    } else {
      this.querySelector('.boxy-crop').classList.add('hidden');
    }
    this.renderSizes(product);
    this.customSizeGuide.dataset.handle = product.handle;
    this.wairSizeGuideAttribute(product);
  }
  renderSizes(product) {
    if (this.variantRadio) this.variantRadio.reInitVariants(product);
  }

  backButtonListener() {
    /**
     * Back button click
     */
    this.backButtonsSelectors.forEach((btn, index) => {
      btn.addEventListener("click", (_) => {
        btn.classList.add("hidden");
        if (this.preorderNote) this.preorderNote.classList.remove("hidden");
        let itemTarget = parseInt(btn.dataset.itemIndex) - 1;
        this.setSetectedItem(itemTarget);

        if (itemTarget != 0)
          this.backButtonsSelectors[itemTarget - 1].classList.remove("hidden");

        let currentCombination = this.selectedCombinations.find(
          (item) => parseInt(item.itemIndex) === itemTarget
        );

        if (currentCombination) {
          this.setSetectedStyle(currentCombination.styleId);
          this.setSelectedProduct(
            currentCombination.product.id,
            currentCombination.styleId
          );
          this.autoScroll(`${currentCombination.styleId}-${currentCombination.product.id}`, currentCombination.styleId);

          const variant = JSON.parse(currentCombination.variant);

          const product = this.availableProducts.find(
            (item) => item.id === currentCombination.product.id
          );

          let optionsForOptions = product.options.map((option, index) => {
            return {
              option_name: option.name,
              option_value: variant.options[index],
            };
          });

          if (this.variantRadio && optionsForOptions)
            this.variantRadio.toEdit = optionsForOptions;

          this.nextButtonsSelectors.forEach((_) => {
            _.classList.add("hidden");
          });
          this.nextButtonsSelectors[index].classList.remove("hidden");
        } else {
          alert("error , please refresh the page");
          console.log(
            "this.selectedCombinations : ",
            this.selectedCombinations
          );
          console.log("currentCombination : ", currentCombination);
          console.log("itemTarget : ", itemTarget);
        }
      });
    });
  }
  backButtonLogic(index) {
    /**
     * Back button show
     */
    this.backButtonsSelectors.forEach((btn) => {
      btn.classList.add("hidden");
    });
    if (this.backButtonsSelectors[index]) {
      this.backButtonsSelectors[index].classList.remove("hidden");
    }
  }
  nextButtonListener() {
    let mbProduct = {};
    if (this.mainProductJSONSelector) {
      const jsonStringMB = this.mainProductJSONSelector.innerHTML;
      mbProduct = JSON.parse(jsonStringMB);
    }
    this.multibundleEvents(this.mbStep, mbProduct?.main_product?.id, mbProduct?.main_product?.title);
    this.mbStep += 1;
    this.nextButtonsSelectors.forEach((btn, index) => {
      btn.addEventListener("click", (_) => {
        let selectedItemBtn = this.querySelector(
          `.mb__interface-item[data-item-index="${index}"]`
        );

        console.log(this.selectedItem);

        let errorMessage = ``;
        if (selectedItemBtn)
          errorMessage = this.querySelector(`.addtocart-error.${selectedItemBtn.dataset.itemType}`);

        if (btn.dataset.disabled == "false") {
          // selected item btn

          if (errorMessage)
            errorMessage.style.display = 'none';

          this.backButtonLogic(index);
          /* Hide all exepting the following next button */
          this.nextButtonsSelectors.forEach((item) => {
            item.classList.add("hidden");
          });
          let nextButton = this.nextButtonsSelectors[index + 1];
          if (nextButton) nextButton.classList.remove("hidden");

          /* validate id exist on itemId */
          const itemIndex = btn.dataset.itemIndex;
          const selectedVariant = btn.dataset.selectedVariant;
          const existingIndex = this.selectedCombinations.findIndex(
            (combination) => combination.itemIndex === itemIndex
          );
          if (existingIndex !== -1) {
            // Replace existing combination
            this.selectedCombinations[existingIndex] = {
              variant: selectedVariant,
              product: this.selectedProduct,
              itemIndex: itemIndex,
              styleId: this.selectedStyle,
            };
          } else {
            // Add new combination
            this.selectedCombinations.push({
              variant: selectedVariant,
              product: this.selectedProduct,
              itemIndex: itemIndex,
              styleId: this.selectedStyle,
            });

            //this.setSetectedItem();
          }
          /* validate id exist on itemId end */

          /**
           * TODO : FINISH THIS
           */

          if (!btn.classList.contains("last")) {
            this.setSetectedItem(index + 1);

            // redirect to  #mb-header

            const element = document.getElementById("mb-header");
            if (element) {
              element.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
              });
            }

            this.multibundleEvents( this.mbStep, mbProduct?.main_product?.id, mbProduct?.main_product?.title);
            this.mbStep += 1;
            if(btn.classList.contains("next-to-last") && this.preorderNote) this.preorderNote.classList.add("hidden");

          } else {

            if (!this.enable_review) {
              nextButton.classList.add("loading");
              //disable the next button
              nextButton.dataset.disabled = "true";
              nextButton.classList.add("disabled");
              this.addToCartAction();
              this.multibundleEvents(this.mbStep, mbProduct?.main_product?.id, mbProduct?.main_product?.title);
              return;
            }


            this.querySelector('#cards-top').classList.add('hidden');
            if (this.itemSelectors[index]) this.itemSelectors[index].classList.add("checked");

            
            this.bundleInterface.classList.add("hidden");
            
            
            

            this.previewInterface.classList.remove("hidden");
            let previewList =
              this.previewInterface.querySelector("#mb__preview-list");
            previewList.innerHTML = "";
            let price = 0;

            this.selectedCombinations.forEach((item) => {
              const variant = JSON.parse(item.variant);
              price += variant.price;


              if (variant) {
                let optionsForOptions = item.product.options.map(
                  (option, index) => {
                    return {
                      option_name: option.name,
                      option_value: variant.options[index],
                    };
                  }
                );
                let colorBubble = "";
                let size = optionsForOptions.find(
                  (obj) => obj.option_name === `${this.size_text}`
                );

                if (!size) {
                  size = `${this.waist_text} ${optionsForOptions.find((obj) => obj.option_name === `${this.waist_text}`)
                    .option_value
                    } ${this.inseam_text} ${optionsForOptions.find((obj) => obj.option_name === `${this.inseam_text}`)
                      .option_value
                    }`;
                } else {
                  size = optionsForOptions.find(
                    (obj) => obj.option_name === `${this.size_text}`
                  ).option_value;
                }

                const color = optionsForOptions.find(
                  (obj) => obj.option_name === "Color" || obj.option_name === "Couleur"
                ).option_value;
                if (color) {
                  colorBubble = `
                                      <div  class="color-picker" >
                                        <span class="color-picker__render ${color.toLowerCase()}"></span>
                                      </div>
                                    `;
                }

                const firstImage = item.product.media.find(image => image.alt !== "PLP-EXCLUSIVE");

                const src = firstImage ? firstImage.src : null;

                const etitButton = `
                                  <button 
                                      class="mb__preview-item--edit mb__edit" 
                                      data-options-object="${JSON.stringify(
                  optionsForOptions
                ).replaceAll(`"`, `'`)}" 
                                      data-style-id="${item.styleId}" 
                                      data-product-id="${item.product.id}" data-item-index="${item.itemIndex
                  }">
                                        ${this.edit_text}
                                      </button>
                                  `;

                let div = `
                                  <div class="mb__preview-item">
                                    <div class="mb__preview-item--info">
                                      <img class="mb__preview-item--img" src="${src}" width="100" data-full-media="" />
                                      <div class="mb__preview-item--desc">
                                        <p>${item.product.title}</p>
                                        <span class="mb__preview-item--color" > <b> ${this.color_text}:</b> <span class="mb__preview-item--color-line" >${colorBubble} ${color}</span></span>
                                        <span class="mb__preview-item--color" > <b> ${this.size_text}:</b> <span>${size}</span>   </span>
                                        
                                      </div>
                                    </div>
                                      ${etitButton}
                                    </div>
                                  `;
                previewList.innerHTML += div;
              } else {
                console.log("variant error: ", item);
              }
            });
            let discountedPrice = price - price * (this.discountPercentage / 100);
            this.totalPrice = `${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(price / 100) }-${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(discountedPrice / 100)}`;
            this.descriptionTab.classList.add("hidden");
            this.descriptionTabRet.classList.add("hidden");
            setTimeout(() => {
              this.editBtnListener();
              this.addtoCartBtn.classList.remove("hidden");
              this.previewInterface.querySelector('#mb__preview-prices').innerHTML = `<span class="mb__preview-prices-total">${this.totalPrice.split('-')[0]} ${window.theme.shop_currency}</span> <span class="mb__preview-prices-discounted">${this.totalPrice.split('-')[1]} ${window.theme.shop_currency}</span>`;

            }, 500);
          }
        } else {
          if (errorMessage)
            errorMessage.style.display = 'block';
          this.variantRadio.classList.add('no-select');
          setTimeout(() => {
            this.variantRadio.classList.remove('no-select');
          }, 500);
        }
      });
    });
  }
  editBtnListener() {
    this.querySelectorAll(".mb__edit").forEach((btn) => {
      btn.addEventListener("click", (_) => {
        this.descriptionTab.classList.remove("hidden");
        let selectedOptions = JSON.parse(
          btn.dataset.optionsObject.replaceAll(`'`, `"`)
        );

        this.bundleInterface.classList.remove("hidden");

        this.setSetectedItem(btn.dataset.itemIndex);
        this.setSetectedStyle(btn.dataset.styleId);

        if (this.variantRadio && selectedOptions)
          this.variantRadio.toEdit = selectedOptions;

        this.setSelectedProduct(btn.dataset.productId, btn.dataset.styleId);
        this.autoScroll(`${btn.dataset.styleId}-${btn.dataset.productId}`, btn.dataset.styleId);

        const saveBtn = this.querySelector(
          ".mb__interface-next-button.save-changes"
        );

        this.addtoCartBtn.classList.add("hidden");
        saveBtn.classList.remove("hidden");
        saveBtn.dataset.itemIndex = btn.dataset.itemIndex;
        this.previewInterface.classList.add("hidden");
      });
    });
  }
  resetBundle() {
    if (this.preorderNote) this.preorderNote.classList.remove("hidden");
    const saveBtn = this.querySelector(
      ".mb__interface-next-button.save-changes"
    );
    //reset bundle to default state
    this.setSetectedItem(0);
    if (this.enable_start) this.startBuilding.classList.remove("hidden");
    this.priceFromTo.classList.remove("hidden");
    this.bundleInterface.classList.add("hidden");
    this.descriptionTab.classList.add("hidden");
    this.descriptionTabRet.classList.add("hidden");
    this.bundleInterface.classList.remove("active");

    this.nextButtonsSelectors[0].classList.remove("hidden");
    this.previewInterface.classList.add("hidden");
    this.addtoCartBtn.classList.add("hidden");
    saveBtn.classList.add("hidden");

    this.selectedCombinations = [];
    this.querySelector('#cards-top').classList.remove('hidden');
    if (!this.enable_start) this.startBuildingWithoutButton();
  }
  autoScroll(sectionId, styleId) {
    if (window.innerWidth < 900) {
      const element = document.getElementById(sectionId);

      let topElement = document.getElementById("mb-interface-items"); // Element where it should scroll to the top

      let overflowElement = document.getElementById(`${styleId}-overlay`); // Element that has overflow-x scroll
      // Element that is inside the overflowElement, sometimes at the right and requires scrolling to make it visible

      if (element) {
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - 200;

        // Scroll to the topElement
        if (topElement) {
          topElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        }

        // Scroll to the productSelector inside the overflowElement
        if (overflowElement && element) {
          const scrollLeft = element.getBoundingClientRect().left;
          if (scrollLeft > 350) {
            overflowElement.scrollTo({
              left: scrollLeft,
              behavior: "smooth",
            });
          }
        } else {
          console.log('error');
          console.log(overflowElement);
          console.log(element);
        }
      }
    }
  }

  multibundleEvents(step, productId, productTitle) {
    let steps_total = this.itemSelectors.length;
    if (step <= steps_total) {
      dataLayer.push({
        event: 'multibundle_step',
        ecommerce: {
          items: [
            {
              item_id: productId,
              item_name: productTitle,
              step: step,
              steps_total: this.itemSelectors.length
            }
          ]
        }
      });
    }
  }
}

customElements.define("multi-bundle", MultiBundle);